import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StreApp } from 'src/app/models/streapp.model';

@Component({
    selector: 'app-streapp-dialog',
    templateUrl: './streapp-dialog.component.html',
    styleUrls: ['./streapp-dialog.component.scss'],
    standalone: false
})
export class StreAppDialogComponent {

  constructor(private readonly dialogRef: MatDialogRef<StreAppDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: StreApp) { 
    }

  closeWithConfirm(): void {
    this.dialogRef.close(true);
  }

  close() : void {
    this.dialogRef.close(false);
  }

  getImageSource(): string {
    if (this.validURL(this.data.thumbnail)) {
      // this is a photo streapp use full image;
      return this.data.thumbnail;
    } else {
      return 'data:image/jpeg;base64,' + this.data.thumbnail;
    }
  }

  private validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
}
